/** Mirrors Report::REASON_SEL_CHILD_SAFETY in app/Model/Moderation/Report.php. */
export const CHILD_SAFETY_REASON = 'child_safety';
